import { Box } from "@mui/material";
import { memo } from "react";
import { Then } from "./Then";
import { If } from "./If";

export const AutomationRuleEncMessageFields = memo(
  ({ idMessage }: { idMessage?: string }) => {
    return (
      <Box sx={{ pl: 2 }}>
        <If idMessage={idMessage} />
        <Then />
      </Box>
    );
  }
);
